<template>
  <div v-if="currentRoles.name === '模板管理'" class="page-index label-manage-edit">
    <div style="padding: 30px;">
      <div class="toolbar-box">
        <detail-back page="label-manage" :query="query" :interval="interval"></detail-back>
        <div style="flex:1"></div>
        <el-button v-if="currentRoles.roles['模板管理-新增']" class="btn-left" size="mini" @click="submitLabel">保存</el-button>
      </div>
      <div class="tms-block">
        <div class="edit-box">
          <el-form ref="labelForm" :model="detail">
            <el-row :gutter="20">
              <el-col :span="12">
                <!-- <el-form-item label="模板logo">
                  <div class="el-input">
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <upload-image-cropper ref="logo" :fixedNumber="[1, 1]" width="70" height="70"></upload-image-cropper>
                      </el-col>
                      <el-col :span="12">
                        <img v-if="detail.logoUrlPath" :src="detail.logoUrlPath" width="70" height="70" />
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item> -->
                <el-form-item label="模板logo">
                  <el-select class="search-input" @change="logoChange" v-model="logoIndex" placeholder="请选择模板logo">
                    <el-option v-for="(item, index) in materialList" :key="item.id" :label="item.name" :value="index"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <img v-if="logoIndex !== '' && logoIndex > -1" :src="materialList[logoIndex].urlPath" width="70" height="70" style="position: relative;top: 20px;" />
              </el-col>
              <el-col :span="6">
                <img v-if="detail.logoUrlPath" :src="detail.logoUrlPath" width="70" height="70" style="position: relative;top: 20px;" />
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="模板名称">
                  <el-input placeholder="请输入模板名称" v-model="detail.name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司">
                  <el-select class="search-input" v-model="detail.companyId" @change="getLicense" placeholder="请选择公司">
                    <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div class="pr-box">
                  <el-form-item label="许可证">
                    <el-select class="search-input" v-model="detail.companyLicense" placeholder="请选择许可证">
                      <el-option v-for="item in licenseList" :key="item.id" :label="item.licenseNumber" :value="item.licenseNumber"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-button class="btn-left" @click="handleAdd(true)" size="mini">添加</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="是否委托" label-width="80px" class="switch-label">
                  <el-switch
                    v-model="isEntrust"
                    active-color="#13ce66"
                    inactive-color="#606266">
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="isEntrust">
              <el-col :span="12">
                <el-form-item label="委托公司">
                  <el-select class="search-input" v-model="detail.entrustCompanyId" @change="getEntrustLicense" placeholder="请选择委托公司">
                    <el-option v-for="item in entrustList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div class="pr-box">
                  <el-form-item label="委托公司许可证">
                    <el-select class="search-input" v-model="detail.entrustCompanyLicense" placeholder="请选择委托公司许可证">
                      <el-option v-for="item in entrustLicenseList" :key="item.id" :label="item.licenseNumber" :value="item.licenseNumber"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-button class="btn-left" @click="handleAdd(false)" size="mini">添加</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="pr-box">
                  <el-form-item label="商品">
                    <el-select
                        class="search-input"
                        filterable
                        remote
                        :remote-method="getProductList"
                        v-model="detail.product.id"
                        @change="changeProduct"
                        placeholder="请选择商品">
                      <el-option v-for="item in productList" :key="item.id" :label="item.name + '(' + item.code + ')'" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-button class="btn-left" @click="handleSap" size="mini">sap导入</el-button>
                </div>
              </el-col>
              <el-col :span="12">
                <el-form-item label="产品标准编号">
                  <el-input placeholder="请输入产品标准编号" v-model="detail.standardNumber"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item class="mt-no" label="净含量">
                  <el-input placeholder="请输入净含量" v-model="detail.netWeight"></el-input>
                </el-form-item>
                <div style="color:red;margin-bottom:22px">例：20kg</div>
              </el-col>
              <el-col :span="12">
                <el-form-item class="mt-no" label="保质期">
                  <el-input placeholder="请输入保质期" v-model="detail.period"></el-input>
                </el-form-item>
                <div style="color:red;margin-bottom:22px">例：三个月</div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="复用模板">
                  <!-- <el-select class="search-input" v-model="detail.labelModuleId" placeholder="请选择模板">
                    <el-option v-for="item in labelModuleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select> -->
                  <el-select
                      class="search-input"
                      filterable
                      remote
                      :remote-method="getLabelModule"
                      v-model="detail.labelModuleId"
                      @change="changeLabel"
                      placeholder="请选择模板">
                    <el-option v-for="item in labelModuleList" :key="item.id" :label="item.name" :value="item.number"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div class="preview-box">
          <iframe
            v-if="pid !== ''"
            id="iframe"
            :src="root + 'service/buildPage.jsp?tid=' + detail.labelModuleId + '&pid=' + pid"
            frameborder="0"
            scrolling="no"
            style="background:#fff;">
          </iframe>
        </div>
      </div>
    </div>

    <el-dialog
        :visible.sync="dialogVisible"
        :show-close="false"
        class="dialog"
        width="400px">
      <el-row :gutter="20">
        <el-col :span="symbol === '-' ? 12 : 16">
          <el-select class="search-input" v-model="symbol">
            <el-option label="大于等于" value="≥"></el-option>
            <el-option label="小于等于" value="≤"></el-option>
            <el-option label="大于" value=">"></el-option>
            <el-option label="小于" value="<"></el-option>
            <el-option label="两者之间" value="-"></el-option>
          </el-select>
        </el-col>
        <el-col :span="symbol === '-' ? 6 : 8">
          <el-input placeholder="成分值" v-model="currentComponentValue"></el-input>
        </el-col>
        <el-col :span="6" v-if="symbol === '-'">
          <el-input placeholder="成分值" v-model="currentComponentValue2"></el-input>
        </el-col>
      </el-row>
      <div style="display:flex;margin-top:10px">
        <div style="flex:1"></div>
        <el-button class="btn-left" @click="componentChange">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
        :visible.sync="dialogVisible2"
        :show-close="false"
        class="dialog"
        width="400px">
      <el-form ref="productForm" :model="form">
        <el-form-item label="许可证">
          <el-input placeholder="请输入许可证" v-model="form.licenseNumber"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button v-if="licenseFlag" type="primary" @click="handleAddLicense">确 定</el-button>
        <el-button v-if="!licenseFlag" type="primary" @click="handleAddEntrustLicense">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        :visible.sync="dialogVisible3"
        :show-close="false"
        class="dialog"
        width="300px">
      <div>当前为模板编辑模式，复用模板会替换掉原有的模板，是否确认选择复用模板</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleA(false)">取 消</el-button>
        <el-button type="primary" @click="handleA(true)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import DetailBack from '../../components/detail-back/detail-back'
  import { formatDate, dynamicChangeRoute, dataFormart } from '../../utils/common'
  import { apiDetail, apiLabelModuleList, apiLabelEdit as apiEdit, apiCopyLabel, apiGetPid, apiBuildPage } from '../../api/label'
  import { view } from '../../api/labelPrint'
  import { apiList as apiProductList, apiDetail as apiProductDetail, apiSap } from '../../api/product'
  import { apiFeedStage, apiSortName, apiType } from '../../api/master'
  import { apiLicense, apiLicenseAdd } from '../../api/organization'
  import { apiList as apiEntrustList, apiEntrustLicenseAdd } from '../../api/entrust'
  import { Message } from 'element-ui'
  import { apiUpload } from '../../api/file'
  import { apiList as apiMaterialList } from '../../api/material'
  import { getJCP } from '../../../public/jcp'
  import DDDY from '../../../public/dddy'
  // import UploadImageCropper from '../../components/upload-image-cropper/upload-image-cropper'

  export default {
    mixins: [tableMixin],
    name: 'label-manage-edit',
    data() {
      return {
        id: 0,
        detail: {}, // 模板详情
        licenseFlag: true, // 许可证添加控制 ture分公司 false委托公司,
        form: {},
        pid: '',
        key: '',
        root: process.env.VUE_APP_DDDY_ROOT,
        interval: 0,
        query: {}, // 页面跳转的参数
        materialList: {}, // 素材列表
        logoIndex: '', // 素材index
        licenseList: [], // 分公司许可证
        isEntrust: false, // 是否委托
        entrustList: [], // 委托公司列表
        entrustLicenseList: [], // 委托公司许可证
        productList: [], // 商品列表
        copyProductList: [], // 复用商品列表
        copyProductId: '', // 复用的商品Id
        labelModuleList: [], // 模板模板列表
        labelEditFlag: true, // 编辑时复用提示
        copyLabelModuleId: '', // 复用模板id
        dialogVisible3: false, // 复用提示框
        feedStageList: [], // 饲喂阶段列表
        sortNameList: [], // 通用名列表
        componentList: [], // 成分列表（二维数组）
        productIngredients: [], // 成分列表
        currentComponent: {}, // 当前成分
        dialogVisible: false, // 成分弹窗
        dialogVisible2: false, // 许可证弹窗
        symbol: '≥', // 符号
        currentComponentValue: '', // 当前成分值
        currentComponentValue2: '' // 当前成分值2
      }
    },
    components: {
      DetailBack
      // UploadImageCropper
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      this.detail = {
        id: 0,
        name: '',
        labelModuleId: '',
        companyId: '',
        companyLicense: '',
        entrustCompanyId: '',
        entrustCompanyLicense: '',
        logoUrl: '',
        logoUrlPath: '',
        netWeight: '',
        period: '',
        standardNumber: '',
        product: {
          id: '',
          name: '',
          sortName: '',
          feedStage: '',
          standardNumber: '',
          productIngredients: [{
            value: ''
          }],
          material: '',
          netWeight: '',
          period: ''
        }
      }
    },
    activated() {
      this.query = this.$route.query || this.query
      this.key = (localStorage.getItem('companyCode') || '').toLowerCase() + '_' + (localStorage.getItem('account') || '')
      this.clearAllData()
      this.pid = ''
      this.id = this.$route.params.id
      if (this.id === '0') {
        this.detail.companyId = this.userInfo.companyList[0].id
      }
      this.getLabelDetail()
      // this.getEntrustList()
      // this.getEntrustLicense()
      // this.getFeedStage()
      // this.getSortName()
      // this.getComponent()
      function reinitIframe() {
        try {
          var iframe = document.getElementById('iframe')
          var bHeight = iframe.contentWindow.document.body.scrollHeight
          var dHeight = iframe.contentWindow.document.documentElement.scrollHeight
          var height = Math.max(bHeight, dHeight)
          iframe.height = height
          var imgTags = iframe.contentWindow.document.getElementsByTagName('img')
          for (let i = 0; i < imgTags.length; i++) {
            try {
              if (imgTags[i].dataset.style.indexOf('type:qr;') !== -1) {
                imgTags[i].src = 'http://127.0.0.1:31227/api?type=coder&code=test&style=type%3Aqr%3Bbar-color%3A%23000000%3Bautofit%3Atrue&width=53&height=51&'
                imgTags[i].dataset.style = ''
              }
              if (imgTags[i].dataset.style.indexOf('type:code39;') !== -1) {
                imgTags[i].src = 'http://127.0.0.1:31227/api?type=coder&code=TEST000000001&style=type%3Acode39%3Bbar-color%3A%23000000%3Btext-color%3A%23000000%3Bfont-size%3A20%3Bfont-name%3AACaslonPro-Bold%3Bautofit%3Atrue&width=204&height=55&'
                imgTags[i].dataset.style = ''
              }
            } catch (ex) {}
          }
        } catch (ex) {}
      }
      this.interval = window.setInterval(function() {
        reinitIframe()
      }, 1000)
    },
    methods: {
      // 获取token
      getToken() {
        let that = this
        DDDY.getToken(that.key, function(result) {
          if (result.token) {
            this.token = result.token
          }
        })
      },
      // 提交
      submitLabel() {
        let params = Object.assign({}, this.detail)
        if (params.name === '') {
          this.$message({
            type: 'warning',
            message: '请输入模板名称'
          })
          return
        }
        if (params.compnayId === '') {
          this.$message({
            type: 'warning',
            message: '请选择公司'
          })
          return
        }
        if (params.companyLicense === '') {
          this.$message({
            type: 'warning',
            message: '请选择许可证'
          })
          return
        }
        if (params.product.id === '') {
          this.$message({
            type: 'warning',
            message: '请选择商品'
          })
          return
        }
        if (params.standardNumber === '') {
          this.$message({
            type: 'warning',
            message: '请输入产品标准编号'
          })
          return
        }
        if (params.netWeight === '') {
          this.$message({
            type: 'warning',
            message: '请输入净含量'
          })
          return
        }
        if (params.period === '') {
          this.$message({
            type: 'warning',
            message: '请输入保质期'
          })
          return
        }
        if (params.id === 0) {
          params.id = null
        }
        if (!this.isEntrust) {
          params.entrustCompanyId = null
          params.entrustCompanyLicense = null
        } else {
          if (params.entrustCompanyId === '') {
            this.$message({
              type: 'warning',
              message: '请选择委托公司'
            })
            return
          }
          if (params.entrustCompanyLicense === '') {
            this.$message({
              type: 'warning',
              message: '请选择委托公司许可证'
            })
            return
          }
        }
        params.productId = params.product.id
        params.product.standardNumber = params.standardNumber
        params.product.netWeight = params.netWeight
        params.product.period = params.period
        apiEdit(params, params.companyId).then(data => {
          if (params.id === 0 || params.id === null) {
            this.$message({
              type: 'success',
              message: '新增成功'
            })
            if (params.labelModuleId) {
              // 复制模板
              apiCopyLabel(params.labelModuleId, data.data.number).then(res => {
                if (res.success) {
                  // 打开模板
                  this.openTemplate(data)
                }
              })
            } else {
              // 新建模板
              this.newTemplate(data)
            }
            this.query.query = ''
            this.query.pageIndex = 1
            this.query.status = '0'
          } else {
            this.$message({
              type: 'success',
              message: '修改成功'
            })
            if (params.labelModuleId) {
              // 复制模板
              apiCopyLabel(params.labelModuleId, data.data.number).then(res => {
                if (res.success) {
                  // 打开模板
                  this.openTemplate(data)
                }
              })
            } else {
              // 打开模板
              this.openTemplate(data)
            }
          }
          window.clearInterval(this.interval)
          this.$router.push({ name: 'label-manage', query: this.query })
        })
      },
      setDataset(data) {
        let entrust = this.entrustList.filter(item => {
          return item.id === this.detail.entrustCompanyId
        })
        let dataset = JSON.stringify([{
          '唯一码': 'TEST000000001-0001',
          '条形码': 'TEST000000001',
          '模板logo': data.data.logoUrlPath || '测试图片无法显示',
          '产品名称': data.data.product ? data.data.product.name : '打印测试产品名称',
          '产品标准编号': data.data.standardNumber ? '产品标准编号：' + data.data.standardNumber : '打印测试产品标准编号',
          '生产日期': '生产日期：' + formatDate(new Date(), 'YYYY年MM月DD日'),
          '净含量': data.data.netWeight ? '净含量：' + data.data.netWeight : '',
          '保质期': data.data.period ? '保质期为' + data.data.period : '',
          '二维码': '打印测试',
          '畜牧局二维码': '打印测试',
          '合格证': 'http://dddy.sen-chang.cn/tms-resources/01.png',
          '公司名称': '生产者名称: ' + (data.data.organization.name || '打印测试公司'),
          '生产许可证': '饲料生产许可证编号：' + (data.data.companyLicense || '打印测试许可证'),
          '公司生产地址': '生产地址：' + (data.data.organization.address || '打印测试地址'),
          '公司注册地址': '注册地址：' + (data.data.organization.registerAddress || '打印测试注册地址'),
          '公司邮政编码': '邮编：' + (data.data.organization.postcode || '打印测试邮编'),
          '公司联系方式': '电话/传真：' + (data.data.organization.contactNumber || '打印测试联系方式') + '/' + (data.data.organization.tel || '打印测试传真'),
          '委托方公司名称': '委托企业：' + (entrust.length > 0 ? entrust[0].name : '打印测试委托公司'),
          '委托方许可证号': this.detail.entrustCompanyLicense || '打印测试许可证',
          '委托方公司生产地址': '委托方生产地址：' + (entrust.length > 0 ? entrust[0].address : '打印测试生产地址'),
          '委托方公司注册地址': '委托方注册地址：' + (entrust.length > 0 ? entrust[0].registerAddress : '打印测试注册地址'),
          '委托方公司联系方式': '电话：' + (entrust.length > 0 ? entrust[0].contactNumber : '打印测试联系方式'),
          '委托方公司邮政编码': '邮编：' + (entrust.length > 0 ? entrust[0].postcode : '打印测试邮政编码')
        }])
        return dataset
      },
      newTemplate(data) {
        let that = this
        let dataset = this.setDataset(data)
        let datasource = '唯一码\n条形码\n模板logo\n产品名称\n产品标准编号\n生产日期\n二维码\n畜牧局二维码\n合格证\n公司名称\n公司许可证\n公司地址\n公司注册地址\n公司邮政编码\n公司联系方式\n委托方公司名称\n委托方许可证号\n委托方公司生产地址\n委托方公司注册地址\n委托方公司联系方式\n委托方公司邮政编码'
        DDDY.getToken(that.key, function(result) {
          if (result.token) {
            DDDY.newTemplate(result.token, datasource, dataset, data.data.number, function(result) {
              if (result.error_code) {
                alert(result.error_message)
              }
            }, function(result) {
              if (result.error_code) {
                alert(result.error_message)
              }
            })
          } else {
            alert('token获取失败，无法打开模板')
          }
        })
      },
      // 打开模板
      openTemplate(data) {
        let that = this
        let dataset = that.setDataset(data)
        DDDY.getToken(that.key, function(result) {
          if (result.token) {
            DDDY.openTemplate(result.token, data.data.number, dataset, function(result) {
              if (result.error_code) {
                if (result.error_message.indexOf('该 tid 报表不存在') !== -1) {
                  that.newTemplate(data)
                }
              }
            }, function(result) {
              if (result.error_code) {
                alert(result.error_message)
              }
            })
          } else {
            alert('token获取失败，无法打开模板')
          }
        })
      },
      // 许可证弹窗 flag true:分公司 false:委托公司
      handleAdd(flag) {
        this.dialogVisible2 = true
        this.licenseFlag = flag
        this.form = {
          licenseNumber: ''
        }
      },
      // 添加许可证
      handleAddLicense() {
        if (this.detail.companyId === '') {
          this.$message({
            type: 'warning',
            message: '请选择公司'
          })
        } else {
          if (this.form.licenseNumber === '') {
            this.$message({
              type: 'warning',
              message: '请输入许可证号'
            })
            return
          }
          apiLicenseAdd(this.detail.companyId, this.form.licenseNumber).then(() => {
            this.$message({
              type: 'success',
              message: '添加许可证成功'
            })
            this.dialogVisible2 = false
            this.detail.companyLicense = this.form.licenseNumber
            this.getLicense()
          })
        }
      },
      // 添加委托许可证
      handleAddEntrustLicense() {
        if (this.detail.entrustCompanyId === '') {
          this.$message({
            type: 'warning',
            message: '请选择委托公司'
          })
        } else {
          if (this.form.licenseNumber === '') {
            this.$message({
              type: 'warning',
              message: '请输入许可证号'
            })
            return
          }
          apiEntrustLicenseAdd(this.detail.entrustCompanyId, this.form.licenseNumber).then(() => {
            this.$message({
              type: 'success',
              message: '添加委托公司许可证成功'
            })
            this.dialogVisible2 = false
            this.detail.entrustCompanyLicense = this.form.licenseNumber
            this.getEntrustLicense()
          })
        }
      },
      // 获取素材
      getMaterialList() {
        if (this.detail.companyId === '') return
        let params = {
          companyIds: [this.detail.companyId],
          query: ''
        }
        apiMaterialList(params, 1, 1, 999).then(data => {
          this.materialList = data.data.data
        })
      },
      // 获取模板详情
      getLabelDetail() {
        if (this.id === '0') {
          this.getEntrustList()
          this.getEntrustLicense()
          this.getProductList('')
          this.getLabelModule('')
          this.getLicense()
          this.getMaterialList()
        } else {
          apiDetail(this.id).then(data => {
            this.copyObject(this.detail, data.data)
            if (!(this.detail.labelModuleId)) {
              this.detail.labelModuleId = ''
            }
            if (this.detail.product.id) {
              this.getProductList(this.detail.product.name)
            }
            if (this.detail.companyId > 0) {
              this.getLicense()
            }
            if (this.detail.entrustCompanyId > 0) {
              this.isEntrust = true
            }
            this.getEntrustList()
            this.getEntrustLicense()
            this.getComponent()
            // this.getCopyProductList('')
            this.getLabelModule('')
          })
        }
      },
      // logo变更
      logoChange() {
        this.detail.logoUrl = this.materialList[this.logoIndex].url
      },
      // sap导入
      handleSap() {
        if (this.detail.companyId) {
          apiSap(this.detail.companyId).then(() => {
            this.$message({
              type: 'success',
              message: '导入成功'
            })
            this._getList()
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请选择公司'
          })
        }
      },
      // 获取模板
      getLabelModule(value) {
        if (this.detail.companyId === '') return
        apiLabelModuleList(this.detail.companyId, value).then(data => {
          this.labelModuleList = [{
            id: '',
            name: '',
            number: ''
          }, ...data.data]
        })
      },
      // 获取分公司许可证列表
      getLicense() {
        if (this.detail.companyId === '') return
        this.getMaterialList() // 获取素材
        apiLicense(this.detail.companyId, 1).then(data => {
          this.licenseList = data.data
        })
        if (this.isEntrust) {
          this.getEntrustList()
        }
      },
      // 获取委托公司许可证列表
      getEntrustLicense() {
        if (this.detail.entrustCompanyId === '' || this.detail.entrustCompanyId === null) return
        apiLicense(this.detail.entrustCompanyId, 2).then(data => {
          this.entrustLicenseList = data.data
        })
      },
      // 获取委托公司列表
      getEntrustList() {
        if (this.detail.companyId === '') return
        let searchCondition = {
          companyIds: [this.detail.companyId]
        }
        apiEntrustList(searchCondition, 1, 999).then(data => {
          this.entrustList = data.data.data
        })
      },
      // 获取商品列表
      getProductList(value) {
        if (this.detail.companyId === '') return
        let params = {
          companyIds: [this.detail.companyId],
          query: value
        }
        apiProductList(params, 0, 1, 30).then(data => {
          this.productList = data.data.data
        })
      },
      // 获取复用商品列表
      getCopyProductList(value) {
        if (this.detail.companyId === '') return
        apiProductList(this.detail.companyId, value, 0, '', 1, 10).then(data => {
          this.copyProductList = data.data.data
        })
      },
      changeProduct() {
        apiProductDetail(this.detail.product.id).then(data => {
          let product = {
            id: '',
            name: '',
            sortName: '',
            feedStage: '',
            standardNumber: '',
            productIngredients: [],
            material: '',
            netWeight: '',
            period: ''
          }
          this.copyObject(product, data.data)
          this.productIngredients.forEach((item, index) => {
            if (product.productIngredients.length < this.productIngredients.length) {
              product.productIngredients[index] = {
                type: item.value,
                value: data.data.productIngredients[index] ? data.data.productIngredients[index].value : ''
              }
            } else {
              if (product.productIngredients[index].value === undefined) {
                product.productIngredients[index].value = ''
              }
            }
          })
          this.detail.product = product
        })
      },
      // 复用商品信息
      copyProductDetail() {
        if (this.copyProductId === '' || this.copyProductId === 0) return
        apiProductDetail(this.copyProductId).then(data => {
          let product = this.detail.product
          // let copyProduct = Object.assign({}, data.data, product)
          this.copyObject(product, data.data, false)
          this.detail.product = product
        })
      },
      // 获取商品饲喂阶段选择列表
      getFeedStage() {
        apiFeedStage().then(data => {
          this.feedStageList = data.data
        })
      },
      // 获取商品通用名选择列表
      getSortName() {
        apiSortName().then(data => {
          this.sortNameList = data.data
        })
      },
      // 获取商品配料类型选择列表
      getComponent() {
        let productIngredients = JSON.parse(JSON.stringify(this.detail.product.productIngredients))
        apiType().then(data => {
          let a = []
          let b = []
          this.productIngredients = data.data
          data.data.forEach((item, index) => {
            if (productIngredients.length < data.data.length) {
              productIngredients[index] = {
                type: item.value,
                value: ''
              }
            } else {
              if (productIngredients[index].value === undefined) {
                productIngredients[index].value = ''
              }
            }
            if (index !== 0 && index % 3 === 0) {
              a.push(b)
              b = []
              b.push(item)
            } else if (index + 1 === data.data.length && (index + 1) % 3 !== 0) {
              b.push(item)
              for (let i = 0; i < (3 - (data.data.length % 3)); i++) {
                b.push({
                  description: '-',
                  value: '-'
                })
              }
              a.push(b)
            } else if (index + 1 === data.data.length && (index + 1) % 3 === 0) {
              b.push(item)
              a.push(b)
            } else {
              b.push(item)
            }
          })
          this.detail.product.productIngredients = productIngredients
          this.componentList = a
        })
      },
      // 成分值弹框
      toast(index) {
        this.dialogVisible = true
        this.currentComponentValue = ''
        this.currentComponentValue2 = ''
        let currentComponent = this.detail.product.productIngredients[index]
        if (currentComponent.value) {
          if (currentComponent.value.indexOf('-') !== -1) {
            this.symbol = '-'
            this.currentComponentValue = currentComponent.value.split('-')[0]
            this.currentComponentValue2 = currentComponent.value.split('-')[1]
          } else if (currentComponent.value.indexOf('≥') !== -1) {
            this.symbol = '≥'
            this.currentComponentValue = currentComponent.value.split('≥')[1]
          } else if (currentComponent.value.indexOf('≤') !== -1) {
            this.symbol = '≤'
            this.currentComponentValue = currentComponent.value.split('≤')[1]
          } else if (currentComponent.value.indexOf('>') !== -1) {
            this.symbol = '>'
            this.currentComponentValue = currentComponent.value.split('>')[1]
          } else if (currentComponent.value.indexOf('<') !== -1) {
            this.symbol = '<'
            this.currentComponentValue = currentComponent.value.split('<')[1]
          }
        } else {
          this.symbol = '≥'
        }
        currentComponent.index = index
        this.currentComponent = currentComponent
      },
      // 成分值修改
      componentChange() {
        let currentComponent = this.currentComponent
        let symbol = this.symbol
        let value = this.currentComponentValue
        let value2 = this.currentComponentValue2
        let i = currentComponent.index
        if (symbol === '-') {
          if (value2 > value && value && value2) {
            this.detail.product.productIngredients[i].value = value + symbol + value2
          } else {
            Message.error('后者的值必须大于前者的值或值不能为空')
            return
          }
        } else {
          if (value) {
            this.detail.product.productIngredients[i].value = symbol + value
          } else {
            Message.error('值不能为空')
            return
          }
        }
        this.dialogVisible = false
      },
      // 对象赋值
      copyObject(obj1, obj2, flag = true) {
        for (let i in obj1) {
          for (let j in obj2) {
            if (typeof obj1[i] !== 'object') {
              if (i === j) {
                if (flag) {
                  obj1[i] = obj2[j]
                } else {
                  if (obj1[i] === '') {
                    obj1[i] = obj2[j]
                  }
                }
              }
            } else {
              if (i === j) {
                this.copyObject(obj1[i], obj2[j])
              }
            }
          }
        }
      },
      handleA(flag) {
        // this.labelEditFlag = false
        if (!flag) {
          this.pid = ''
          this.detail.labelModuleId = ''
        } else {
          this.detail.labelModuleId = this.copyLabelModuleId
          this.getPID(this.detail.id)
        }
        this.dialogVisible3 = false
      },
      changeLabel(number) {
        if (this.detail.id > 0) {
          if (this.labelEditFlag) {
            this.copyLabelModuleId = this.detail.labelModuleId
            this.detail.labelModuleId = ''
            this.pid = ''
            this.dialogVisible3 = true
            return
          }
        }
        let labelId = this.labelModuleList[this.labelModuleList.findIndex(item => item.number === number)].id
        this.getPID(labelId)
      },
      getPID(labelId) {
        view(labelId, formatDate(new Date(), 'YYYY-MM-DD')).then(data => {
          let dataset = JSON.stringify(dataFormart([data.data]))
          let that = this
          DDDY.getToken(that.key, function(result) {
            if (result.token) {
              apiGetPid(result.token, that.detail.labelModuleId, dataset).then(res => {
                if (res.error_code === 0) {
                  that.pid = res.pid
                } else if (res.error_code === 1) {
                  that.pid = ''
                } else {
                  that.pid = ''
                }
              })
            }
          })
        })
      },
      // 清除数据
      clearAllData() {
        this.id = 0
        this.logoIndex = ''
        this.detail = {
          id: 0,
          name: '',
          labelModuleId: '',
          companyId: '',
          companyLicense: '',
          entrustCompanyId: '',
          entrustCompanyLicense: '',
          logoUrl: '',
          logoUrlPath: '',
          standardNumber: '',
          netWeight: '',
          period: '',
          product: {
            id: '',
            name: '',
            sortName: '',
            feedStage: '',
            standardNumber: '',
            productIngredients: [{
              value: ''
            }],
            material: '',
            netWeight: '',
            period: ''
          }
        }
        this.licenseList = []
        this.isEntrust = false
        this.entrustList = []
        this.entrustLicenseList = []
        this.productList = []
        this.copyProductList = []
        this.copyProductId = ''
        this.labelModuleList = []
        this.feedStageList = []
        this.sortNameList = []
        this.componentList = []
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.label-manage-edit
    height calc(100vh - 60px - 51px)
    padding 0
    .tms-block
      height calc(100vh - 60px - 51px - 30px - 10px - 36px - 10px - 30px - 20px)
      overflow-y auto
    .mt-no
      margin-bottom 0
    .pr-box
      position relative
      button
        position absolute
        right 0
        top 0
        z-index 999
    .preview-box
      // height 100%
      background #fff
    .el-dialog__header
      padding 0
    .edit-box
      background #fff
      padding 20px
      padding-top 0
    .table-box
      border-collapse collapse
      display table
      width 100%
      td
        text-align center
        padding 5px 10px
        border 1px solid #DDD
        width calc(100% / 6)
    .switch-label
      .el-form-item__label
        text-align left
    .el-form-item__content > div
      width 100%
    .btn-left
      background #A5CE1C
      color #fff
    .el-table
      .has-gutter
        th
          background #F5F7FA
          border-right 1px solid #EBEEF5
          border-top 1px solid #ebeef5
    .toolbar-box
      display flex
      margin 10px 0
      .search-input
        width 150px
        margin-right 10px
        .el-input__inner
          height 36px
          line-height 36px
      .select-box
        width 120px
        margin-right 10px
    .upload
      .el-upload
        width 100%
        .el-upload-dragger
          width 100%
  .el-select-dropdown__item.selected
    span
      max-width none
</style>
